/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The strategy of the choosing optimal trip start time:   * `EARLIEST_FINISH`   * `LOWEST_COST` 
 */
export enum TripStartTimeStrategyLastmile {
    EARLIEST_FINISH = 'EARLIEST_FINISH',
    LOWEST_COST = 'LOWEST_COST'
};

